import { fetchApi } from '../client';

export type ReferralSource =
  | 'walk_in'
  | 'existing_patient'
  | 'google'
  | 'social_media'
  | 'doctor_referral'
  | 'advertisement'
  | 'other';

export type RewardType = 'NONE' | 'DISCOUNT' | 'FREE_CONSULTATION' | 'CREDIT';
export type ReferralStatus = 'PENDING' | 'CONVERTED' | 'REWARDED' | 'CANCELLED';

export interface PatientReferral {
  id: string;
  clinicId: string;
  referredPatientId: string;
  referrerPatientId?: string;
  referralSource: ReferralSource;
  rewardType: RewardType;
  rewardValue: number;
  rewardApplied: boolean;
  rewardAppliedAt?: string;
  status: ReferralStatus;
  createdAt: string;
  updatedAt: string;
}

export interface ReferralStats {
  total: number;
  converted: number;
  conversionRate: number;
  bySource: Record<string, number>;
  topReferrerCount: number;
}

export const REFERRAL_SOURCE_LABELS: Record<ReferralSource, string> = {
  walk_in:          'Walk-in',
  existing_patient: 'Referred by Patient',
  google:           'Google Search',
  social_media:     'Social Media',
  doctor_referral:  'Doctor Referral',
  advertisement:    'Advertisement',
  other:            'Other',
};

export const referralsModule = {
  record: (referredPatientId: string, referralSource: ReferralSource, referrerPatientId?: string) =>
    fetchApi<PatientReferral>('/api/referrals', {
      method: 'POST',
      body: JSON.stringify({ referredPatientId, referralSource, referrerPatientId }),
    }),

  list: () =>
    fetchApi<PatientReferral[]>('/api/referrals'),

  getStats: () =>
    fetchApi<ReferralStats>('/api/referrals/stats'),

  byReferrer: (patientId: string) =>
    fetchApi<PatientReferral[]>(`/api/referrals/patient/${patientId}`),

  applyReward: (id: string, rewardType: RewardType, rewardValue: number) =>
    fetchApi<PatientReferral>(`/api/referrals/${id}/reward`, {
      method: 'POST',
      body: JSON.stringify({ rewardType, rewardValue }),
    }),
};
